import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var IconText = function IconText(props) {
  return React.createElement("div", {
    className: props.className
  }, React.createElement("div", null, props.icon), React.createElement("div", null, props.children));
};
export default styled(IconText).withConfig({
  displayName: "IconText",
  componentId: "sc-wi9xm4-0"
})(["display:flex;align-items:center;padding-bottom:32px;&:first-of-type{margin-top:56px;}svg{width:56px;height:56px;}& > :first-child{display:flex;align-items:center;padding-right:46px;}", ";"], maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    &:first-of-type {\n      margin-top: 32px;\n    }\n\n    svg {\n      width: 40px;\n      height: 40px;\n    }\n\n    & > :first-child {\n      padding-right: 16px;\n    }\n  "]))));